import { Delete } from "../services/api_helpers";

export const DeleteAccount = (data) => {
  return Delete("delete-account/", data);
};